<template>
  <div>
    <el-select :placeholder="$t('Şəhər_Rayon')" filterable :value="selected" @input="handleInput" style="width: 100%">
      <el-option v-for="item in data" :key="item.id" :label="item.name" :value="item.id" />
    </el-select>
  </div>
</template>

<script>
import { GetRegions } from "../../services/cls";
import { GetCommRegions } from "../../services/commregion";

export default {
  props: {
    value: [Number, String],
  },
  data() {
    return {
      data: [],
      commRegions: [],
      selected: this.value,
    };
  },
  watch: {
    value(newVal) {
      this.selected = newVal;
    },
  },
  methods: {
    fetchCommRegions() {
      return GetCommRegions().then(res => {
        if (res.data?.data) {
          const arr = res.data.data;
          this.commRegions = arr
            .map(x => x.regionName)
            .filter(Boolean)
            .flatMap(x => x.split(","))
            .map(x => x.trim().toLowerCase());
        } else {
          this.commRegions = [];
        }
      });
    },

    setRegionFromSearch(searchName) {
      if (!searchName || !this.data.length) return false;

      const regionAllowed = this.commRegions.some(r =>
        r.includes(searchName.toLowerCase())
      );

      if (!regionAllowed) return false;

      const foundRegion = this.data.find(region =>
        region.name.toLowerCase().includes(searchName.toLowerCase()) ||
        searchName.toLowerCase().includes(region.name.toLowerCase())
      );

      if (foundRegion) {
        this.selected = foundRegion.id;
        this.$emit("input", foundRegion.id);
        this.$emit("region", foundRegion.name);
        return true;
      }

      return false;
    },


    handleInput(e) {
      this.selected = e;
      this.$emit("input", e);
      const selectedRegion = this.data.find(i => i.id === e);
      if (selectedRegion) this.$emit("region", selectedRegion.name);
    },

    async getData() {
      await this.fetchCommRegions();
      const res = await GetRegions();
      if (res.data?.data) this.data = res.data.data;
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
